import { render, staticRenderFns } from "./ModalPrivacy.vue?vue&type=template&id=9bc12648"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports